module.exports = __webpack_public_path__ + "static/banner_logo-0cd4cacddeae966d9b455446d75fb7c9.svg";